<template>

    <div :style="{ height: size + 'px', width: size + 'px' }">

        <lottie
                :options="defaultOptions"
                v-on:animCreated="handleAnimation"
        />

    </div>

</template>

<script>

import Lottie from 'vue-lottie'

import * as animationData from '../../../public/img/lottie/loader/data-loader.json'

export default {

    name: 'lottie-loader',

    components: { Lottie },

    props: {

        size: {
            type: Number,
            default: 40
        }
    },

    data () {
        return {
            defaultOptions: { animationData: animationData.default },
            anim: null
        }
    },

    methods: {

        handleAnimation: function (anim) {
            this.anim = anim
        },

        stop: function () {
            this.anim.stop()
        },

        play: function () {
            this.anim.play()
        },

        pause: function () {
            this.anim.pause()
        },

        onSpeedChange: function () {
            this.anim.setSpeed(this.animationSpeed)
        }
    }

}

</script>

<style scoped lang="scss"></style>
